module.exports = require('./helpers/bundle-url').getBundleURL('4KXYA') + "logo.c51670a8.svg";